"use strict";
/*
 * Copyright 2020 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyService = void 0;

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var DtoMapping_1 = require("../core/utils/DtoMapping");

var mosaic_1 = require("../model/mosaic");

var namespace_1 = require("../model/namespace");
/**
 * A service used to load Currencies objects.
 */


var CurrencyService = /*#__PURE__*/function () {
  function CurrencyService(repositoryFactory) {
    _classCallCheck(this, CurrencyService);

    this.repositoryFactory = repositoryFactory;
  }
  /**
   * This method loads the network currencies.
   */


  _createClass(CurrencyService, [{
    key: "getNetworkCurrencies",
    value: function getNetworkCurrencies() {
      var _this = this;

      return this.repositoryFactory.createNetworkRepository().getNetworkProperties().pipe((0, operators_1.mergeMap)(function (properties) {
        if (!properties.chain.currencyMosaicId) {
          throw new Error('currencyMosaicId could not be loaded from network properties!!');
        }

        if (!properties.chain.harvestingMosaicId) {
          throw new Error('harvestingMosaicId could not be loaded from network properties!!');
        }

        var currencyMosaic = new mosaic_1.MosaicId(DtoMapping_1.DtoMapping.toSimpleHex(properties.chain.currencyMosaicId));
        var harvestingMosaic = new mosaic_1.MosaicId(DtoMapping_1.DtoMapping.toSimpleHex(properties.chain.harvestingMosaicId));
        var mosaicIds = currencyMosaic.equals(harvestingMosaic) ? [currencyMosaic] : [currencyMosaic, harvestingMosaic];
        return _this.getCurrencies(mosaicIds).pipe((0, operators_1.map)(function (networkCurrencies) {
          var currency = networkCurrencies.filter(function (c) {
            return currencyMosaic.equals(c.mosaicId);
          })[0];
          var harvest = networkCurrencies.filter(function (c) {
            return harvestingMosaic.equals(c.mosaicId);
          })[0];
          return new mosaic_1.NetworkCurrencies(currency, harvest);
        }));
      }));
    }
  }, {
    key: "getCurrencies",
    value: function getCurrencies(mosaicIds) {
      var _this2 = this;

      var mosaicHttp = this.repositoryFactory.createMosaicRepository();
      var namespaceHttp = this.repositoryFactory.createNamespaceRepository(); // get mosaicInfo and mosaic names from the network,
      // build network currency models

      return (0, rxjs_1.forkJoin)({
        mosaicsInfo: (0, rxjs_1.firstValueFrom)(mosaicHttp.getMosaics(mosaicIds)),
        mosaicNames: (0, rxjs_1.firstValueFrom)(namespaceHttp.getMosaicsNames(mosaicIds))
      }).pipe((0, operators_1.map)(function (_ref) {
        var mosaicsInfo = _ref.mosaicsInfo,
            mosaicNames = _ref.mosaicNames;
        return mosaicsInfo.map(function (mosaicInfo) {
          var thisMosaicNames = mosaicNames.find(function (mn) {
            return mn.mosaicId.equals(mosaicInfo.id);
          }) || new mosaic_1.MosaicNames(mosaicInfo.id, []);
          return _this2.getCurrency(mosaicInfo, thisMosaicNames);
        });
      }));
    }
    /**
     * Creates a network currency model given mosaic info and mosaic names
     * @param {MosaicInfo} mosaicInfo
     * @param {MosaicNames} mosaicName
     * @returns {(Currency | undefined)}
     */

  }, {
    key: "getCurrency",
    value: function getCurrency(mosaicInfo, mosaicName) {
      var mosaicId = mosaicInfo.id;
      var namespaceName = this.getName([mosaicName], mosaicId);
      var namespaceId = namespaceName ? new namespace_1.NamespaceId(namespaceName) : undefined;
      return new mosaic_1.Currency({
        mosaicId: mosaicId,
        namespaceId: namespaceId,
        divisibility: mosaicInfo.divisibility,
        transferable: mosaicInfo.flags.transferable,
        supplyMutable: mosaicInfo.flags.supplyMutable,
        restrictable: mosaicInfo.flags.restrictable
      });
    }
  }, {
    key: "getName",
    value: function getName(mosaicNames, accountMosaicDto) {
      var _a;

      return (_a = mosaicNames.filter(function (n) {
        return n.mosaicId.equals(accountMosaicDto);
      }).filter(function (n) {
        return n.names.length;
      }).map(function (n) {
        return n.names[0].name;
      })) === null || _a === void 0 ? void 0 : _a[0];
    }
  }]);

  return CurrencyService;
}();

exports.CurrencyService = CurrencyService;